import axios from 'axios';
import { AxiosInstance } from 'axios';

import { LockedPricingBotConfig } from '../../typedefs/external';
import { VisitorState } from '../../typedefs/store';

let settings: any = {
    baseUrl: null,
    senderId: null,
    visitorToken: null,
    channel: null,
};
let api: AxiosInstance;

export const setBaseUrl = (url: string) => {
    settings.baseUrl = url;
};

export const setSenderId = (senderId: string) => {
    settings.senderId = senderId;
};

export const initApi = (visitorToken: string, channel: string): void => {
    settings.visitorToken = visitorToken;
    settings.channel = channel;

    api = axios.create({
        baseURL: `${settings.baseUrl}`,
        timeout: 10000,
        headers: {
            'X-Api-Version': '2.0.0',
            'x-visitor-token': visitorToken,
        },
    });
};

export const fetchSettings = (guid: string): Promise<any> => {
    return api.get(`/embed/settings/${guid}`);
};

export const hasIncentives = (
    locationId: number,
    vehicleOfInterest: object,
    visitor: VisitorState,
): Promise<any> => {
    return api.post(`/n/embed/offers`, {
        locationId,
        vehicleOfInterest,
        contactInfo: visitor.contactInfo,
    });
};

export const startBotConvo = (
    locationId: number,
    botId: number,
    visitor: VisitorState,
    customMetadata?: string,
    extraContext?: { [key: string]: any },
    initialVisitorMessage?: string,
): Promise<any> => {
    return api.post(`/n/bot/start`, {
        locationId,
        botId,
        senderId: visitor.senderId,
        dateOnSite: visitor.sessionStarted,
        gaClientId: visitor.gaClientId,
        roxanneVisitorId: visitor.roxanneVisitorId,
        contactInfo: visitor.contactInfo,
        customMetadata,
        extraContext,
        initialVisitorMessage,
    });
};

export const startLockedPricingConvo = (
    locationId: number,
    botId: number,
    visitor: VisitorState,
    config: LockedPricingBotConfig,
    customMetadata?: string,
): Promise<any> => {
    return api.post(`/n/bot/start/locked_pricing`, {
        locationId,
        botId,
        senderId: visitor.senderId,
        dateOnSite: visitor.sessionStarted,
        gaClientId: visitor.gaClientId,
        roxanneVisitorId: visitor.roxanneVisitorId,
        vehicleInfo: config.vehicle,
        onlineShopperInfo: config.onlineShopper,
        contactInfo: visitor.contactInfo,
        customMetadata,
    });
};

export const sendMessage = (messageText: string, type?: string, category?: string) => {
    return api.post(`/n/bot/visitor/message`, {
        channel: settings.channel,
        messageText,
        type,
        category,
    });
};

export const getTranscript = () => {
    return api.get(`/conversation/visitor/transcript`, {
        params: { channelName: settings.channel },
    });
};

export const getConversationDetails = () => {
    return api.get(`/conversation/visitor/show`, { params: { channelName: settings.channel } });
};

export const endConvo = () => {
    return api.post('/conversation/visitor/end', { channelName: settings.channel });
};

export const saveSurveyScore = (score: number) => {
    return api.post('/conversation/visitor/survey', { channel_name: settings.channel, score });
};

export const markMessagesRead = (messageIds: number[]) => {
    return api.post('/conversation/visitor/mark/read', { messageId: messageIds });
};

export const leaveMessage = (data: {
    teamId: number;
    firstName: string;
    lastName: string;
    message: string;
    email?: string;
    phone?: string;
    url?: string;
}) => {
    return api.post('/conversation/visitor/leavemessage', {
        team_id: data.teamId,
        first_name: data.firstName,
        last_name: data.lastName,
        message: data.message,
        email: data.email,
        phone_home: data.phone,
        url: data.url,
    });
};



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/api/index.ts